/*
 * Le composant diaporama (Diaporama) supporte 3 langues (fr, en, de), extensibles avec "addLang".
 * Lancer "jquery-diaporama.html" pour avoir une idée du fonctionnement de ce composant.
 *
 * Il supporte différents types de fichiers via des extensions (DiaporamaSupport) de base ou ajoutées par "addSupport" :
 * - ImageSupport : affiche des images dont le format est supporté par les navigateurs (jpeg, png, svg...)
 * - GifSupport : cas particulier pour les images Gif, de manière assez basique (pas de rotation, pas de zoom...)
 * - AudioSupport : lance la lecture de piste audio, avec une animation visuelle, pour les formats supportés par les navigateurs (mp3, wav, oga, ogg...)
 * - VideoSupport : lance la lecture de piste vidéo, avec le son si dispo, pour les formats supportés par les navigateurs (mp4, ogv, webm...)
 * - PDFSupport : permet la consultation de fichiers PDF, avec zoom, changement de page, rotation... grâce à PDF.js (http://mozilla.github.io/pdf.js)
 *
 * Visuellement, il est découpé en 4 zones :
 * - en haut, la barre d'outil qui permettra de manipuler le fichier en cours de fisualisation (changer de page, zoomer, pivoter, mettre en pause...)
 * - en bas, un bandeau masquable affichant les miniatures des entrées du diaporama. Cliquer une miniature lancer la lecture du fichier correspondant
 * - au centre, la visualisation avec le maximum d'espace du fichier sélectionné
 * - à droite, dans une zone facultative et personnalisée, la possibilité d'afficher des infos sur le fichier (date, créateur, voire plus complexe comme une carte) 
 */
window.loadDiaporamaAPI = function($, pdfjsLib) {
	"use strict";

	var THUMBNAIL_WIDTH = 80;
	var THUMBNAIL_HEIGHT = 80;
	var THUMBNAIL_PADDING = 10; /*5px de chaque côté*/
	var THUMBNAIL_MARGIN = 10; /*5px de chaque côté*/

	var frenchLocale = {
		download: 'Télécharger',
		showFirstPage: 'Première page',
		showPreviousPage: 'Page précédente',
		showPageIndex: 'Page ',
		showPageOf: ' sur ',
		showNextPage: 'Page suivante',
		showLastPage: 'Dernière page',
		zoomOut: 'Zoom arrière',
		zoomRealSize: 'Taille réelle',
		zoomFitPage: 'Page entière',
		zoomFitWidth: 'Pleine largeur',
		zoomIn: 'Zoom avant',
		rotateCCW: 'Rotation anti-horaire',
		rotateCW: 'Rotation horaire',
		play: 'Démarrer',
		pause: 'Pause',
		resume: 'Reprendre',
		mute: 'Couper le son',
		unmute: 'Activer le son',
		remove: 'Supprimer',
		close: 'Fermer le diaporama',

		currentItemFormat: '%position sur %count',
		showPreviousItem: 'Image précédente',
		showNextItem: 'Image suivante',
		showThumbnails: 'Afficher les miniatures',
		hideThumbnails: 'Cacher les miniatures',
		showDetails: 'Afficher le détail',
		hideDetails: 'Cacher le détail',
		contentError: 'Erreur à la lecture du contenu'
	};

	var englishLocale = {
		download: 'Download',
		showFirstPage: 'Show first page',
		showPreviousPage: 'Show previous page',
		showPageIndex: 'Page ',
		showPageOf: ' of ',
		showNextPage: 'Show next page',
		showLastPage: 'Show last page',
		zoomOut: 'Zoom out',
		zoomRealSize: 'Actual size',
		zoomFitPage: 'Fit page',
		zoomFitWidth: 'Fit width',
		zoomIn: 'Zoom in',
		rotateCCW: 'Rotation anti-horaire',
		rotateCW: 'Rotation horaire',
		play: 'Play',
		pause: 'Pause',
		resume: 'Resume',
		mute: 'Mute',
		unmute: 'Unmute',
		remove: 'Delete',
		close: 'Close diaporama',

		currentItemFormat: '%position of %count',
		showPreviousItem: 'Show previous item',
		showNextItem: 'Show next item',
		showThumbnails: 'Show thumbnail panel',
		hideThumbnails: 'Hide thumbnail panel',
		showDetails: 'Show details',
		hideDetails: 'Hide details',
		contentError: 'An error occurred'
	};

	var germanLocale = {
		download: 'Herunterladen',
		showFirstPage: 'Erste Seite',
		showPreviousPage: 'Vorherige Seite',
		showPageIndex: 'Seite ',
		showPageOf: ' von ',
		showNextPage: 'Nächste Seite',
		showLastPage: 'Letzte Seite',
		zoomOut: 'Verkleinern',
		zoomRealSize: 'Tatsächliche Größe',
		zoomFitPage: 'An Seite anpassen',
		zoomFitWidth: 'An Breite anpassen',
		zoomIn: 'Vergrößern',
		rotateCCW: 'Gegen den Uhrzeigersinn drehen',
		rotateCW: 'Im Uhrzeigersinn drehen',
		play: 'Starten',
		pause: 'Pausieren',
		resume: 'Fortsetzen',
		mute: 'Stumm',
		unmute: 'Aufheben der Stummschaltung',
		remove: 'Löschen',
		close: 'Schließen',

		currentItemFormat: '%position von %count',
		showPreviousItem: 'Vorherige Bild',
		showNextItem: 'Nächste Bild',
		showThumbnails: 'Miniaturbilder anzeigen',
		hideThumbnails: 'Miniaturbilder ausblenden',
		showDetails: 'Eigenshaften anzeigen',
		hideDetails: 'Eigenshaften ausblenden',
		contentError: 'ein Problem ist aufgetreten'
	};

	function ImageSupport() {

		this.getExtensions = function() {
			// IMAGE : http://www.w3schools.com/tags/tag_img.asp
			return ['jpg', 'jpeg', 'png', 'svg'];
		};

		this.buildThumbnail = function(item, span, _width, _height, errorCallback) {
			var div = $('<div style="display: flex; align-items: center; width: 100%; height: 100%; " />');
			var img = $('<img style="flex: none; margin: auto; max-width: 100%; max-height: 100%; " />')
				.attr('src', item.thumbnailUrl || item.url)
				.on('error', errorCallback);
			div.append(img).appendTo(span);
		};

		this.buildContent = function(item, span, callback, errorCallback) {
			$('<img />').attr('src', item.url).on('error', errorCallback).on('load', function() {
				var img = this,
					canvas = $('<canvas />').appendTo(span),
					content = new DiaporamaContent(),
					maxWidthFactor = (span.width() - 20) / img.naturalWidth,
					maxHeightFactor = (span.height() - 20) / img.naturalHeight,
					maxZoom = 100 * Math.min(maxWidthFactor, maxHeightFactor);
				item.img = this;

				function draw() {
					internalDraw(img, canvas[0], content.rotation, content.zoom);
				}

				function zoomTo(value) {
					content.zoom = value;
					draw();
				}

				function zoomToFitPage() {
					var rotated =  (content.rotation % 180) === 90;
					var widthFactor = (span.width() - 20) / (rotated ? img.naturalHeight : img.naturalWidth);
					var heightFactor = (span.height() - 20) / (rotated ? img.naturalWidth : img.naturalHeight);
					content.zoom = 100 * Math.min(widthFactor, heightFactor);
					draw();
				}

				function zoomToFitWidth() {
					var rotated =  (content.rotation % 180) === 90;
					var width = span.width() - 17 /*potential scroll*/;
					var widthFactor = width / (rotated ? img.naturalHeight : img.naturalWidth);
					content.zoom = 100 * widthFactor;
					draw();
				}

				function rotateOf(offset) {
					content.rotation = (content.rotation + 360 + offset) % 360;
					draw();
				}

				callback(content.withZoom(Math.min(100, maxZoom), zoomTo, zoomToFitPage, zoomToFitWidth).withRotation(0, rotateOf));
				draw();
			});
		};

		/**
		 * Une méthode éventuellement réutilisable qui dessine une "img" dans un "canvas" avec rotation (0/90/180/270) et zoom (100=taille réelle)
		 * @param {DOM} img - l'image à dessiner
		 * @param {DOM} canvas - le canvas dans lequel dessiner
		 * @param {Number} rotation - la rotation, en degrés, pouvant être 0, 90, 180 ou 270
		 * @param {Number} zoom - le zoom à appliquer, où 100 représente la taille réelle (100%)
		 */
		function internalDraw(img, canvas, rotation, zoom) {
			// Un jsFiddle qui m'a permis d'ajuster le code pour dessiner une image dans un canvas avec zoom et rotation
			// https://jsfiddle.net/t6qpt1wt/1/
			var parent = $(canvas).parent();
			var context = canvas.getContext('2d');
			var width = img.naturalWidth;
			var height = img.naturalHeight;
			var rotated = rotation === 90 || rotation === 270;
			if (zoom !== 100) {
				width *= zoom / 100;
				height *= zoom / 100;
			}
			canvas.width = rotated ? height : width;
			canvas.height = rotated ? width : height;
			canvas.style.marginLeft = Math.max(0, (parent.width() - canvas.width) / 2) + 'px';
			canvas.style.marginTop = Math.max(0, (parent.height() - canvas.height) / 2) + 'px';
			context.clearRect(0,0,canvas.width,canvas.height);

			if (rotation !== 0) {
				context.translate(Math.round(canvas.width / 2), Math.round(canvas.height / 2));
				context.rotate(rotation * Math.PI / 180);
				context.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, -Math.floor(width / 2), -Math.floor(height / 2), width, height);
				context.rotate(-rotation * Math.PI / 180);
				context.translate(-canvas.width / 2, -canvas.height.h / 2);
			} else {
				context.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, width, height);
			}
		}
	}

	function PDFSupport(pdfjsLib) {
		// Par défaut, le PDF est flou. La variable "canvasQuality" permet de multiplier la densité de pixels
		var quality = 2;
		// Ratio de conversion de pt vers dots (96 dot per inch / 72pt per inch)
		var cssUnits = 96 / 72;

		// PDF : http://mozilla.github.io/pdf.js/
		this.getExtensions = function() {
			return ['pdf'];
		};

		this.buildThumbnail = function(item, span, width, height, errorCallback) {
			pdfjsLib.getDocument(item.url).promise.then(function(pdf) {
				pdf.getPage(1).then(function(page) {
					// Calculate canvas dimensions
					var rotated = (page.rotate % 180) === 90;
					var view = page.view; // [0,0,612,792]
					var pageWidth = rotated ? view[3] : view[2];
					var pageHeight = rotated ? view[2] : view[3];
					if (pageWidth > width) {
						pageHeight = pageHeight * width / pageWidth;
						pageWidth = width;
					}
					if (pageHeight > height) {
						pageWidth = pageWidth * height / pageHeight;
						pageHeight = height;
					}

					// Append canvas
					var canvas = $('<canvas />').appendTo(span).get(0);
					canvas.mozOpaque = true;
					canvas.width = pageWidth;
					canvas.height = pageHeight;
					if (height)
						canvas.style.marginTop = ((height - pageHeight) / 2) + 'px';
					if (width)
						canvas.style.marginLeft = ((width - pageWidth) / 2) + 'px';

					// Draw page
					var rotation = page.rotate;
					var scale = canvas.width / (rotated ? view[3] : view[2]);
					var viewport = page.getViewport({scale: scale, rotation: rotation});
					page.render({
						canvasContext: canvas.getContext('2d', { alpha: false }),
						viewport: viewport
					});
				}, errorCallback);
			}, errorCallback);
		};

		this.buildContent = function(item, span, callback, errorCallback) {
			var content = new DiaporamaContent();
			var canvas = $('<canvas style="box-shadow: 5px 5px 5px #202020; margin: 5px;" />').hide().appendTo(span).get(0);
			var pageRendering = false;
			var pendingDraw = false;
			var pdf;

			function draw() {
				if (pageRendering) {
					// Attendre le fin du dessin en cours avant de prendre en compte les nouveaux paramètres
					pendingDraw = true;
				} else {
					// OK, dessiner la page demandée
					pageRendering = true;
					pdf.getPage(content.pageNumber).then(function(page) {
						var viewport = page.getViewport({
							scale: quality * cssUnits * content.zoom / 100.0,
							rotation: content.rotation
						});
						canvas.mozOpaque = true;
						canvas.height = Math.round(viewport.height);
						canvas.width = Math.round(viewport.width);
						canvas.style.height = Math.round(viewport.height / quality) + 'px';
						canvas.style.width = Math.round(viewport.width / quality) + 'px';
						canvas.style.marginLeft = Math.max(0, (span.width() - viewport.width / quality) / 2 - 5/*box-shadow*/) + 'px';
						canvas.style.marginTop = Math.max(0, (span.height() - viewport.height / quality) / 2 - 5/*box-shadow*/) + 'px';
						page.render({
							canvasContext: canvas.getContext('2d', { alpha: false }),
							viewport: viewport
						}).promise.then(function() {
							pageRendering = false;
							if (pendingDraw) {
								pendingDraw = false;
								draw(false);
							}
						});
					});
				}
			}

			function showPage(pageNumber) {
				content.pageNumber = pageNumber;
				draw();
			}
			function zoomTo(value) {
				content.zoom = value;
				draw();
			}
			function zoomToFitPage() {
				var width = span.width() - 5 /*box-shadow*/ - 5 /*margin-right*/;
				var height = span.height() - 5 /*box-shadow*/ - 5 /*margin-bottom*/;
				var widthFactor = quality * width / canvas.width;
				var heightFactor = quality * height / canvas.height;
				content.zoom = content.zoom * Math.min(widthFactor, heightFactor);
				draw();
			}
			function zoomToFitWidth() {
				var width = span.width() - 17 /*potential scroll*/ - 5 /*box-shadow*/ - 5 /*margin-right*/;
				var widthFactor = quality * width / canvas.width;
				content.zoom = content.zoom * widthFactor;
				draw();
			}
			function rotateOf(offset) {
				content.rotation = (content.rotation + 360 + offset) % 360;
				draw();
			}

			pdfjsLib.getDocument(item.url).promise.then(function(pdfResult) {
				pdf = pdfResult;
				pdf.getPage(1).then(function(page) {
					var rotated = (page.rotate % 180) === 90;
					var view = page.view; // [0,0,612,792]
					canvas.style.display = 'block';
					canvas.width = quality * cssUnits * (rotated ? view[3] : view[2]);
					canvas.height = quality * cssUnits * (rotated ? view[2] : view[3]);
					content
						.withPaging(pdf.numPages, 1, showPage)
						.withZoom(100, zoomTo, zoomToFitPage, zoomToFitWidth)
						.withRotation(page.rotate, rotateOf);
					content.zoomToFitPage();
					callback(content);
				}, errorCallback);
			}, errorCallback);
		};
	}

	function AudioSupport() {

		this.getExtensions = function() {
			// AUDIO : http://www.w3schools.com/tags/tag_audio.asp
			var ua = navigator.userAgent;
			var isIE = (ua.indexOf('MSIE') >= 0 || ua.indexOf('Trident/') >= 0);
			var isSafari = (ua.indexOf('Safari/') >= 0 && ua.indexOf('Chrome/') === -1 && ua.indexOf('Chromium/') === -1);
			if (isIE)
				return ['mp3'];
			if (isSafari)
				return ['mp3', 'wav'];
			return ['mp3', 'wav', 'oga', 'ogg'];
		};

		this.buildThumbnail = function(item, span, width, height, _errorCallback) {
			// La miniature indique simplement qu'il s'agit d'une piste audio
			$(item.thumbnailContent || '<span class="glyphicon glyphicon-volume-up" />')
				.css('width', width + 'px').css('height', height + 'px').css('font-size', height + 'px')
				.appendTo(span);
		};

		function randomColor() {
			// Utilisation de TSV (Teinte Saturation Valeur), plus connue en anglais par HSB (Hue Saturation Brightness).
			// Plus d'infos sur Wikipédia : https://fr.wikipedia.org/wiki/Teinte_Saturation_Valeur
			var t = Math.floor(Math.random() * 360);
			var s = Math.random();
			var v = Math.random();
			var ti = Math.floor(t / 60);
			var f = (t / 60) - ti;
			var l = v * (1 - s);
			var m = v * (1 - f * s);
			var n = v * (1 - (1 - f) * s);
			var to256 = function(n) { return Math.floor(n * 256); };
			switch (ti) {
				case 0: return [v,n,l].map(to256);
				case 1: return [m,v,l].map(to256);
				case 2: return [l,v,n].map(to256);
				case 3: return [l,m,v].map(to256);
				case 4: return [n,l,v].map(to256);
				case 5: return [v,l,m].map(to256);
			}
			throw new Error('Erreur inattendue pour (t,s,v)=(' + [t,s,v].join(',') + ')');
		}

		this.buildContent = function(item, span, callback, errorCallback) {
			var audio = $('<audio loop />')
				.css('width', '100%').css('height', 'auto').attr('src', item.url)
				.appendTo(span);

			function play() {
				audio.get(0).play();
			}
			function pause() {
				audio.get(0).pause();
			}
			function resume() {
				audio.get(0).play();
			}

			audio.on('error', errorCallback).one('canplay', function() {
				callback(new DiaporamaContent().withMedia(play, pause, resume));
			});

			var width = 1152;
			var height = 648;
			var canvas = $('<canvas style="width: 100%; height: 100%; " />')
				.attr('width', width.toString())
				.attr('height', height.toString())
				.prependTo(span);
			var canvascontext = canvas[0].getContext('2d');
			var playing = false;
			var draw;

			var useAudioContext = false; //window.AudioContext || window.webkitAudioContext;
			if (! useAudioContext) {
				var xs = [];
				var ys = [];
				var colors = [];
				var widths = [];
				var gradients = [];
				var randomPoint = function() {
					var color = randomColor();
					xs.push(Math.random() * width);
					ys.push(Math.random() * height);
					colors.push('rgb(' + color.join(',') + ')');
					widths.push(Math.floor(Math.random() * 5) + 1);
					if (xs.length === 1)
						gradients.push(null);
					else {
						var gradient = canvascontext.createLinearGradient(xs[colors.length - 2],ys[colors.length - 2],xs[colors.length - 1],ys[colors.length - 1]);
						gradient.addColorStop(0, colors[colors.length - 2]);
						gradient.addColorStop(1, colors[colors.length - 1]);
						gradients.push(gradient);
					}
					if (xs.length === 10) {
						xs.shift();
						ys.shift();
						colors.shift();
						widths.shift();
						gradients.shift();
					}
				};
				randomPoint();
				randomPoint();

				draw = function() {
					if (playing) {
						canvascontext.fillStyle = 'rgb(0, 0, 0)';
						canvascontext.clearRect(0, 0, width, height);
						// requestAnimationFrame(draw);
						setTimeout(draw, 300);

						for (var i = 1; i < xs.length; i++) {
							var gradient = canvascontext.createLinearGradient(xs[i-1],ys[i-1],xs[i],ys[i]);
							gradient.addColorStop(0, colors[i-1]);
							gradient.addColorStop(1, colors[i]);
							canvascontext.beginPath();
							canvascontext.moveTo(xs[i-1], ys[i-1]);
							canvascontext.strokeStyle = gradients[i];
							canvascontext.lineWidth = widths[i];
							canvascontext.lineTo(xs[i], ys[i]);
							canvascontext.stroke();
						}
						randomPoint();
					}
				};
			} else {
				//audio.crossOrigin = "anonymous";
				// AudioContext : https://developer.mozilla.org/en/docs/Web/API/AudioContext
				// Warning JSHint si on fait comme ci-dessous (https://stackoverflow.com/questions/37435986/how-bad-is-this-constructor-really)
				// var context = new (window.AudioContext || window.webkitAudioContex)();
				window.AudioContext = window.AudioContext || window.webkitAudioContext;
				var context = new window.AudioContext();
				// Fréquence d'échantillonage, par exemple 44100 Hz
				var sampleRate = context.sampleRate;
				// Utilisation de notre <audio /> : https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/createMediaElementSource
				var source = context.createMediaElementSource(audio[0]);
				// AnalyserNode : https://developer.mozilla.org/en-US/docs/Web/API/AnalyserNode
				var analyser = context.createAnalyser();
				// Pour lisser : https://developer.mozilla.org/en-US/docs/Web/API/AnalyserNode/smoothingTimeConstant
				analyser.smoothingTimeConstant = 0.3;
				// Echantillonage : https://developer.mozilla.org/en-US/docs/Web/API/AnalyserNode/fftSize
				analyser.fftSize = 64;
				// Connexion en chaine source -> analyser -> context.destination
				source.connect(analyser);
				analyser.connect(context.destination);
				// Taille du buffer = fftSize / 2 : https://developer.mozilla.org/en-US/docs/Web/API/AnalyserNode/frequencyBinCount
				var bufferLength = analyser.frequencyBinCount;
				// Création du buffer
				var dataArray = new Uint8Array(bufferLength);
				/*
				 * Il est inutile de dessiner toute la plage de fréquence car pas audibles si trop basses ou trop élevées :
				 * - voir ici : https://fr.wikipedia.org/wiki/Acuit%C3%A9_auditive
				 * - "context.sampleRate" nous donne la fréquence d'échantillonage, par exemple 44100 Hz
				 * - pour fftSize = N, on aura frequencyBinCount = N/2 bandes de fréquence dans dataArray
				 * - chaque bande de fréquence "i" va de i*sampleRate/frequencyBinCount à (i+1)*sampleRate/frequencyBinCount
				 * Pour limiter à 20000Hz (soit disant haute fidélité), on prendra la plage où 0 <= i <= 20000 / sampleRate.
				 */
				var range = Math.min(1, 20000 / sampleRate);

				draw = function() {
					canvascontext.fillStyle = 'rgb(0, 0, 0)';
					canvascontext.clearRect(0, 0, width, height);
					if (playing) {
						// requestAnimationFrame(draw);
						setTimeout(draw, 100);

						var barWidth = (width / bufferLength) / range;
						var barHeight;
						analyser.getByteFrequencyData(dataArray); // effet similaire ici : http://vikaslalwani.com/music-player/
						for(var i = 0; i < bufferLength * range; i++) {
							barHeight = Math.floor(height * dataArray[i] / 256);
							canvascontext.fillStyle = 'rgb(' + dataArray[i] + ',50,50)';
							canvascontext.fillRect(Math.floor(barWidth * i), height - barHeight, Math.floor(barWidth - 2), barHeight);
						}
					}
				};
			}

			function toggle() {
				playing = !playing;
			}
			audio.on('play', toggle);
			audio.on('play', draw);
			audio.on('pause', toggle);
			audio.on('ended', toggle);
		};
	}

	function VideoSupport() {

		this.getExtensions = function() {
			// VIDEO : http://www.w3schools.com/tags/tag_video.asp
			var ua = navigator.userAgent;
			var isIE = (ua.indexOf('MSIE') >= 0 || ua.indexOf('Trident/') >= 0);
			var isSafari = (ua.indexOf('Safari/') >= 0 && ua.indexOf('Chrome/') === -1 && ua.indexOf('Chromium/') === -1);
			if (isIE || isSafari)
				return ['mp4'];
			return ['mp4', 'ogv', 'webm'];
		};

		this.buildThumbnail = function(item, span, width, height, errorCallback) {
			$('<video />')
				.css('width', width + 'px').css('height', height + 'px').attr('src', item.url)
				.on('error', errorCallback)
				.appendTo(span);
		};

		this.buildContent = function(item, span, callback, errorCallback) {
			var video = $('<video loop />')
				.css('width', '100%').css('height', '100%').attr('src', item.url)
				.appendTo(span);

			function play() {
				video.get(0).play();
			}
			function pause() {
				video.get(0).pause();
			}
			function resume() {
				video.get(0).play();
			}
			function mute() {
				video.get(0).muted = true;
			}
			function unmute() {
				video.get(0).muted = false;
			}

			video.on('error', errorCallback).one('canplay', function() {
				callback(new DiaporamaContent().withMedia(play, pause, resume).withMute(mute, unmute));
			});
		};
	}
	
	function GifSupport() {
		this.getExtensions = function() {
			return ['gif'];
		};

		this.buildThumbnail = function(item, span, _width, _height, errorCallback) {
			var div = $('<div style="display: flex; align-items: center; width: 100%; height: 100%; " />');
			var img = $('<img style="flex: none; margin: auto; max-width: 100%; max-height: 100%; " />')
				.attr('src', item.thumbnailUrl || item.url)
				.on('error', errorCallback);
			div.append(img).appendTo(span);
		};

		this.buildContent = function(item, span, callback, errorCallback) {
			$('<img />').attr('src', item.url).on('error', errorCallback).on('load', function() {
				var gif = $(this).appendTo(span);
				gif[0].style.marginLeft = Math.max(0, (span.width() - gif[0].width) / 2) + 'px';
				gif[0].style.marginTop = Math.max(0, (span.height() - gif[0].height) / 2) + 'px';
				callback(new DiaporamaContent());
			});
		};
	}

	/**
	 * Cette classe clarifie le contrat de l'objet retourné par les méthodes "buildContent" des différents types d'éléments.
	 *
	 * - par défaut, l'objet ne support aucune fonction. La barre d'action est donc vide
	 * - chaque types activent les fonctions souhaitées en appelant l'une des méthodes "withPaging", "withZoom", "withRotation", "withMedia" ou "withMute"
	 * - chaque méthode indique le contrat à remplir pour que ça fonctionne
	 *
	 * Par exemple, pour supporter la rotation, il faudra appeler "withRotation" en fournissant la rotation initiale (généralement 0) et une méthode permettant de pivoter.
	 */
	function DiaporamaContent() {
		this.supportsPaging = false;
		this.supportsZoom = false;
		this.supportsRotation = false;
		this.supportsMedia = false;
		this.supportsMute = false;
	}

	/**
	 * Cette méthode active le support de la pagination, par exemple pour les PDF
	 * @param {Number} pageCount - le nombre de page total du contenu chargé
	 * @param {Number} pageNumber - la page affichée initialement (a priori 1)
	 * @param {Function(pageNumber)} showPage - une fonction permettant de changer de page
	 */
	DiaporamaContent.prototype.withPaging = function(pageCount, pageNumber, showPage) {
		this.supportsPaging = pageCount > 1;
		this.pageCount = pageCount;
		this.pageNumber = pageNumber;
		this.showPage = showPage;
		return this;
	};

	/**
	 * Cette méthode active le support du zoom, par exemple pour les PDF et les images
	 * @param {Number} zoom - le zoom initial, par exemple 100 (pour 100%)
	 * @param {Function(zoom)} zoomTo - une fonction permettant de changer le zoom à une valeur donnée
	 * @param {Function(width, height)} zoomToFitPage - une fonction demandant d'ajuster le zoom pour que le contenu passe pile dans la page de taille donnée
	 * @param {Function(width)} zoomToFitWidth - une fonction demandant d'ajuster le zoom pour que le contenu s'affiche pile sur la largeur donnée
	 */
	DiaporamaContent.prototype.withZoom = function(zoom, zoomTo, zoomToFitPage, zoomToFitWidth) {
		this.supportsZoom = true;
		this.zoom = zoom;
		this.zoomTo = zoomTo;
		this.zoomToFitPage = zoomToFitPage;
		this.zoomToFitWidth = zoomToFitWidth;
		return this;
	};

	/**
	 * Cette méthode active le support de la rotation, par exemple pour les PDF et les images
	 * @param {Number} rotation - la rotation initiale, en degrés (généralement 0)
	 * @param {Function(offset)} rotateOf - une fonction permettant de pivoter la vue (offset vaudra 90° ou -90° et s'ajoutera à la rotation en cours)
	 */
	DiaporamaContent.prototype.withRotation = function(rotation, rotateOf) {
		this.supportsRotation = true;
		this.rotation = rotation;
		this.rotateOf = rotateOf;
		return this;
	};

	/**
	 * Cette méthode active le support des fonctions play/pause/resume sur les médias, par exemple pour les sons et vidéos
	 * @param {Function} play - une fonction permettant de démarrer le média
	 * @param {Function} pause - une fonction permettant de mettre en pause
	 * @param {Function} resume - une fonction permettant de reprendre la lecture quand on a mis en pause
	 */
	DiaporamaContent.prototype.withMedia = function(play, pause, resume) {
		this.supportsMedia = true;
		this.play = play;
		this.pause = pause;
		this.resume = resume;
		return this;
	};

	/**
	 * Cette méthode active le support des fonctions mute/unmute, par exemple pour les vidéos. (pas pour les sons car un son sans son ne sert à rien :-))
	 * @param {Function} mute - une fonction permettant de couper le son
	 * @param {Function} unmute - une fonction permettant de remettre le son
	 */
	DiaporamaContent.prototype.withMute = function(mute, unmute) {
		this.supportsMute = true;
		this.mute = mute;
		this.unmute = unmute;
		return this;
	};

	/**
	 * Cette classe représente le diaporama lui-même, c'est à dire le controlleur qui affiche dans "target" un diaporama
	 * pour les éléments "items". "options" est facultatif et permet si on le veut de personnaliser (la langue, le premier élément affiché, ...)
	 * @param {DOM} target - le noeud DOM conteneur pour le diaporama
	 * @param {Array} items - la liste des éléments à afficher dans le diaporama
	 * @param {Object} options - les options facultatives
	 *
	 * Les options sont les suivantes
	 * - {String} lang - la langue, parmi "fr", "en" ou "de" (par défaut : on prend $('html').attr('lang') || navigator.language)
	 * - {Number} index - l'index dans "items" de l'élément à afficher initialement (par défaut : 1)
	 * - {Function} ondetails - une fonction facultative qui activera et alimentera une vue détaillée affichée à droite de l'élément en cours
	 * - {Function} onclose - une fonction facultative qui activera un bouton "Fermer" et sera appelée lors d'un clic sur ce bouton
	 */
	function Diaporama(target, items, options) {
		if (!items || !items.length)
			throw new Error('Impossible de démarrer un diaporama vide');
		options = options || {};

		this.target = $(target).addClass('bbm-diaporama').append(''
				+ '<div class="bbm-diaporama-toolbar">'
				+ '  <a href="#" download="" target="_blank" class="btn btn-default bbm-diaporama-action bbm-diaporama-download"><span class="glyphicon glyphicon-download-alt"></span></a>'
				+ '  <div class="btn-group" role="group">'
				+ '    <button disabled type="button" class="btn btn-default bbm-diaporama-action bbm-diaporama-page-first"><span class="glyphicon glyphicon-step-backward"></span></button>'
				+ '    <button disabled type="button" class="btn btn-default bbm-diaporama-action bbm-diaporama-page-previous"><span class="glyphicon glyphicon-backward"></span></button>'
				+ '    <span class="btn bbm-diaporama-action bbm-diaporama-page-index"><span></span><input style="width: 33px; border: 0; box-shadow: none; text-align: center; " type="text" value="1" /><span> / </span><span>?</span></span>'
				+ '    <button disabled type="button" class="btn btn-default bbm-diaporama-action bbm-diaporama-page-next"><span class="glyphicon glyphicon-forward"></span></button>'
				+ '    <button disabled type="button" class="btn btn-default bbm-diaporama-action bbm-diaporama-page-last"><span class="glyphicon glyphicon-step-forward"></span></button>'
				+ '  </div>'
				+ '  <div class="btn-group" role="group">'
				+ '    <button type="button" class="btn btn-default bbm-diaporama-action bbm-diaporama-zoom-out"><span class="glyphicon glyphicon-minus"></span></button>'
				+ '    <button data-toggle="dropdown" type="button" class="btn btn-default dropdown-toggle bbm-diaporama-action bbm-diaporama-zoom-menu"><span>80 %</span>&nbsp;<span class="caret"></span></button>'
				+ '    <ul class="dropdown-menu">'
				+ '      <li><a class="bbm-diaporama-zoom-real-size" href="#"></a></li>'
				+ '      <li><a class="bbm-diaporama-zoom-fit-page" href="#"></a></li>'
				+ '      <li><a class="bbm-diaporama-zoom-fit-width" href="#"></a></li>'
				+ '      <li role="separator" class="divider"></li>'
				+ '      <li><a href="#" data-value="50">50 %</a></li>'
				+ '      <li><a href="#" data-value="75">75 %</a></li>'
				+ '      <li><a href="#" data-value="100">100 %</a></li>'
				+ '      <li><a href="#" data-value="125">125 %</a></li>'
				+ '      <li><a href="#" data-value="150">150 %</a></li>'
				+ '      <li><a href="#" data-value="200">200 %</a></li>'
				+ '      <li><a href="#" data-value="300">300 %</a></li>'
				+ '      <li><a href="#" data-value="400">400 %</a></li>'
				+ '    </ul>'
				+ '    <button type="button" class="btn btn-default bbm-diaporama-action bbm-diaporama-zoom-in"><span class="glyphicon glyphicon-plus"></span></button>'
				+ '  </div>'
				+ '  <div class="btn-group" role="group">'
				+ '    <button type="button" class="btn btn-default bbm-diaporama-action bbm-diaporama-rotate-ccw"><span style="transform: scaleX(-1);" class="glyphicon glyphicon-share-alt"></span></button>'
				+ '    <button type="button" class="btn btn-default bbm-diaporama-action bbm-diaporama-rotate-cw"><span class="glyphicon glyphicon-share-alt"></span></button>'
				+ '  </div>'
				+ '  <button type="button" class="btn btn-default bbm-diaporama-action bbm-diaporama-play" data-method="play"><span class="glyphicon glyphicon-play"></span></button>'
				+ '  <button type="button" class="btn btn-default bbm-diaporama-action bbm-diaporama-pause" data-method="pause"><span class="glyphicon glyphicon-pause"></span></button>'
				+ '  <button type="button" class="btn btn-default bbm-diaporama-action bbm-diaporama-resume" data-method="resume"><span class="glyphicon glyphicon-play"></span></button>'
				+ '  <button type="button" class="btn btn-default bbm-diaporama-action bbm-diaporama-mute" data-method="mute"><span class="glyphicon glyphicon-volume-off"></span></button>'
				+ '  <button type="button" class="btn btn-default bbm-diaporama-action bbm-diaporama-unmute" data-method="unmute"><span class="glyphicon glyphicon-volume-up"></span></button>'
				+ '  <button type="button" class="btn btn-default bbm-diaporama-action bbm-diaporama-remove"><span class="glyphicon glyphicon-trash"></span></a>'
				+ '  <button type="button" class="btn btn-default bbm-diaporama-close" style="display: none; float: right; "><span class="glyphicon glyphicon-remove"></span></button>'
				+ '</div>'
				+ '<div class="bbm-diaporama-content">'
				+ '  <button class="btn btn-link bbm-diaporama-page-previous"><span class="glyphicon glyphicon-menu-left"></span></button>'
				+ '  <div class="bbm-diaporama-view"></div>'
				+ '  <button class="btn btn-link bbm-diaporama-page-next"><span class="glyphicon glyphicon-menu-right"></span></button>'
				+ '  <button class="btn btn-default bbm-diaporama-open-details"><span class="glyphicon glyphicon-option-vertical"></span></button>'
				+ '  <div class="bbm-diaporama-details">'
				+ '    <button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>'
				+ '  </div>'
				+ '</div>'
				+ '<div class="bbm-diaporama-thumbnails" style="display: none;"></div>'
				+ '<div class="bbm-diaporama-pagination">'
				+ '  <button type="button" class="btn btn-link bbm-diaporama-previous-item"><span class="glyphicon glyphicon-menu-left"></span></button>'
				+ '  <button type="button" class="btn btn-link bbm-diaporama-toggle-thumbnails"><span class="glyphicon glyphicon-th"></span></button>'
				+ '  <button type="button" class="btn btn-link bbm-diaporama-next-item"><span class="glyphicon glyphicon-menu-right"></span></button>'
				+ '  <span class="bbm-diaporama-item-index"></span>'
				+ '</div>'
				+ '');
		this.lang = langs[options.lang || $('html').attr('lang') || navigator.language];
		this.target.find('.bbm-diaporama-download').attr('title', this.lang.download);
		this.target.find('.bbm-diaporama-page-first').attr('title', this.lang.showFirstPage);
		this.target.find('.bbm-diaporama-page-previous').attr('title', this.lang.showPreviousPage);
		this.target.find('.bbm-diaporama-page-next').attr('title', this.lang.showNextPage);
		this.target.find('.bbm-diaporama-page-last').attr('title', this.lang.showLastPage);
		this.target.find('.bbm-diaporama-page-index').children(':first-child').text(this.lang.showPageIndex).next('input').next('span').text(this.lang.showPageOf);
		this.target.find('.bbm-diaporama-zoom-in').attr('title', this.lang.zoomIn);
		this.target.find('.bbm-diaporama-zoom-out').attr('title', this.lang.zoomOut);
		this.target.find('.bbm-diaporama-zoom-real-size').text(this.lang.zoomRealSize);
		this.target.find('.bbm-diaporama-zoom-fit-page').text(this.lang.zoomFitPage);
		this.target.find('.bbm-diaporama-zoom-fit-width').text(this.lang.zoomFitWidth);
		this.target.find('.bbm-diaporama-rotate-ccw').attr('title', this.lang.rotateCCW);
		this.target.find('.bbm-diaporama-rotate-cw').attr('title', this.lang.rotateCW);
		this.target.find('.bbm-diaporama-play').attr('title', this.lang.play);
		this.target.find('.bbm-diaporama-pause').attr('title', this.lang.pause);
		this.target.find('.bbm-diaporama-resume').attr('title', this.lang.resume);
		this.target.find('.bbm-diaporama-mute').attr('title', this.lang.mute);
		this.target.find('.bbm-diaporama-unmute').attr('title', this.lang.unmute);
		this.target.find('.bbm-diaporama-remove').attr('title', this.lang.remove);
		this.target.find('.bbm-diaporama-close').attr('title', this.lang.close);
		this.target.find('.bbm-diaporama-previous-item').attr('title', this.lang.showPreviousItem);
		this.target.find('.bbm-diaporama-toggle-thumbnails').attr('title', this.lang.showThumbnails);
		this.target.find('.bbm-diaporama-next-item').attr('title', this.lang.showNextItem);

		this.oncanremove = options.oncanremove;
		this.onremove = options.onremove;
		this.ondetails = options.ondetails;
		this.onclose = options.onclose;
		this.items = items;
		this.index = undefined;
		this.content = undefined;
		this.resizeTimeout = undefined;

		this.internalConnectEvents();
		this.show(options.index || 0);
	}

	/** Cette méthode détruit le diaporama */
	Diaporama.prototype.destroy = function() {
		this.target.empty().removeClass('bbm-diaporama');
	};

	/** Cette méthode interne en appelée dans le constructeur pour connecter les listeners */
	Diaporama.prototype.internalConnectEvents = function() {

		// Afficher l'élement précédent
		this.target.find('.bbm-diaporama-previous-item').on('click', this.showPrevious.bind(this));
		// Afficher l'élement suivant
		this.target.find('.bbm-diaporama-next-item').on('click', this.showNext.bind(this));
		// Afficher les miniatures afin de sélectionner l'élément souhaité
		this.target.find('.bbm-diaporama-toggle-thumbnails').on('click', this.toggleThumbnails.bind(this));
		// Afficher l'élement demandé quand l'utilisateur clique sur sa miniature
		this.target.find('.bbm-diaporama-thumbnails').on('click', '>span', function(event) {
			this.show($(event.target).closest('.bbm-diaporama-thumbnail').index());
		}.bind(this));
		// Afficher l'élément précédent (resp. suivant) quand la molette va vers le haut (resp. vers le bas)
		if ($.fn.wheelUpDown) {
			this.target.find('.bbm-diaporama-thumbnails').wheelUpDown(null,
					this.showPrevious.bind(this), this.showNext.bind(this));
		}

		if (this.ondetails) {
			this.target.find('.bbm-diaporama-open-details').on('click', this.toggleDetails.bind(this));
			this.target.find('.bbm-diaporama-details .close').on('click', this.toggleDetails.bind(this));
		} else {
			this.target.find('.bbm-diaporama-open-details').hide();
		}

		// Le bouton Remove permet, si l'appelant le décide, de supprimer les PJ directement depuis le diaporama
		if (this.onremove)
			this.target.find('.bbm-diaporama-remove').on('click', this.deleteItem.bind(this));

		// Le bouton en haut à droite permettant de fermer le diaporama
		if (this.onclose)
			this.target.find('.bbm-diaporama-close').show().on('click', this.onclose);

		//===============
		// Paging support
		//===============

		var pageIndexSpan = this.target.find('.bbm-diaporama-page-index');
		function showPage(content, number) {
			content.showPage(number);
			pageIndexSpan.prevAll().prop('disabled', number === 1);
			pageIndexSpan.nextAll().prop('disabled', number === content.pageCount);
			pageIndexSpan.children('input').val(number.toString());
		}
		this.target.find('.bbm-diaporama-page-first').on('click', function() {
			showPage(this.content, 1);
		}.bind(this));
		this.target.find('.bbm-diaporama-page-previous').on('click', function() {
			if (this.content.pageNumber > 1)
				showPage(this.content, this.content.pageNumber - 1);
		}.bind(this));
		this.target.find('.bbm-diaporama-page-next').on('click', function() {
			if (this.content.pageNumber < this.content.pageCount)
				showPage(this.content, this.content.pageNumber + 1);
		}.bind(this));
		this.target.find('.bbm-diaporama-page-last').on('click', function() {
			showPage(this.content, this.content.pageCount);
		}.bind(this));
		pageIndexSpan.children('input').on('change', function(event) {
			var num = parseInt(event.target.value);
			if (num >= 1 && num <= this.content.pageCount)
				showPage(this.content, num);
			else
				event.target.value = this.content.pageNumber.toString();
		}.bind(this));


		//=============
		// Zoom support
		//=============

		var zoomSpan = this.target.find('.bbm-diaporama-zoom-menu > span:first-child');

		// Zoomer un peu plus (+10 entre 0 et 100, +20 entre 100 et 200, +30 entre 200 et 300, ...)
		this.target.find('.bbm-diaporama-zoom-in').on('click', function(event) {
			var increment = (Math.floor(this.content.zoom / 100) + 1) * 10;
			this.content.zoomTo(this.content.zoom + increment);
			zoomSpan.text(Math.floor(this.content.zoom) + ' %');
			event.preventDefault();
		}.bind(this));

		// Zoomer un peu moins (-10 entre 0 et 100, -20 entre 100 et 200, -30 entre 200 et 300, ...)
		this.target.find('.bbm-diaporama-zoom-out').on('click', function(event) {
			var decrement = (Math.floor(this.content.zoom / 100) + 1) * 10;
			this.content.zoomTo(Math.max(10, this.content.zoom - decrement));
			zoomSpan.text(Math.floor(this.content.zoom) + ' %');
			event.preventDefault();
		}.bind(this));

		// Positionner le zoom à 100% (taille réelle)
		this.target.find('.bbm-diaporama-zoom-real-size').on('click', function(event) {
			this.content.zoomTo(100);
			zoomSpan.text('100 %');
			event.preventDefault();
		}.bind(this));

		// Ajuster le zoom pour que la page s'affiche en entière
		this.target.find('.bbm-diaporama-zoom-fit-page').on('click', function(event) {
			this.content.zoomToFitPage();
			zoomSpan.text(this.lang.zoomFitPage);
			event.preventDefault();
		}.bind(this));

		// Ajuster le zoom pour que la page s'affiche en pleine largeur
		this.target.find('.bbm-diaporama-zoom-fit-width').on('click', function(event) {
			this.content.zoomToFitWidth();
			zoomSpan.text(this.lang.zoomFitWidth);
			event.preventDefault();
		}.bind(this));

		// Zoomer à des pourcentage prédéfinis dans le menu
		this.target.find('.bbm-diaporama-zoom-menu').next().on('click', 'a[data-value]', function(event) {
			this.content.zoomTo(parseInt($(event.target).attr('data-value')));
			zoomSpan.text($(event.target).text());
			event.preventDefault();
		}.bind(this));

		// Détecter le redimensionnement pour ajuster le contenu si le zoom est ajusté
		$(window).on('resize', this.internalAutoResize.bind(this));

		//=================
		// Rotation support
		//=================

		// Rotation dans le sens inverse des aiguilles d'une monte (ccw = Counter ClockWise)
		this.target.find('.bbm-diaporama-rotate-ccw').on('click', function() {
			this.content.rotateOf(-90);
		}.bind(this));

		// Rotation dans le sens des aiguilles d'une monte (cw = ClockWise)
		this.target.find('.bbm-diaporama-rotate-cw').on('click', function() {
			this.content.rotateOf(90);
		}.bind(this));

		//==============
		// Media support
		//==============

		// Les 3 boutons Play / Pause / Resume indiquent via l'attribut 'data-method' la méthode à appeler sur "content". Du coup, un listener unique suffit
		this.target.find('.bbm-diaporama-play, .bbm-diaporama-pause, .bbm-diaporama-resume').on('click', function(event) {
			var method = $(event.target).closest('button').attr('data-method');
			this.content[method]();
			this.target.find('.bbm-diaporama-play').hide();
			this.target.find('.bbm-diaporama-pause').toggle(method !== 'pause');
			this.target.find('.bbm-diaporama-resume').toggle(method === 'pause');
		}.bind(this));

		//=============
		// Mute support
		//=============

		// Les 2 boutons Mute / Unmute indiquent aussi via l'attribut 'data-method' la méthode à appeler sur "content". Du coup, un listener unique suffit
		this.target.find('.bbm-diaporama-mute, .bbm-diaporama-unmute').on('click', function(event) {
			var method = $(event.target).closest('button').attr('data-method');
			this.content[method]();
			this.target.find('.bbm-diaporama-mute').toggle(method !== 'mute');
			this.target.find('.bbm-diaporama-unmute').toggle(method === 'mute');
		}.bind(this));
	};

	/** Cette méthode ajuste automatiquement la taille du contenu, si le zoom sélectionné est "ajusté" (à la page ou à la largeur) */
	Diaporama.prototype.internalAutoResize = function() {
		if (this.resizeTimeout)
			clearTimeout(this.resizeTimeout);
		if (this.content && this.content.supportsZoom) {
			this.resizeTimeout = setTimeout(function() {
				var text = this.target.find('.bbm-diaporama-zoom-menu > span:first-child').text();
				if (text === this.lang.zoomFitPage)
					this.content.zoomToFitPage();
				else if (text === this.lang.zoomFitWidth)
					this.content.zoomToFitWidth();
				else
					this.content.zoomTo(this.content.zoom);
			}.bind(this), 200);
		}
	};

	/** Cette méthode vérifie que les miniatures visibles dans la partie inférieure sont bien chargées dynamiquement */
	Diaporama.prototype.internalCheckVisibleThumbnails = function() {
		var parent = this.target.children('.bbm-diaporama-thumbnails').get(0);
		var spans = parent.childNodes;
		var spanWidth = THUMBNAIL_WIDTH + THUMBNAIL_MARGIN + THUMBNAIL_PADDING;
		var parentWidth = parent.clientWidth;
		var parentCapacity = Math.floor(parentWidth / spanWidth)/*nb entier*/ + 2/*un bout avant + un bout après*/;
		var scrollLeft = parent.scrollLeft;
		var start = Math.floor(scrollLeft / spanWidth);
		var stop = Math.min(start + parentCapacity, spans.length);
		function loadThumbnail(index) {
			var span = $(spans[index]);
			if (! span.hasClass('bbm-diaporama-thumbnail-loading'))
				return;
			span.empty().removeClass('bbm-diaporama-thumbnail-loading');
			span.data('type').buildThumbnail(span.data('item'), span, THUMBNAIL_WIDTH, THUMBNAIL_HEIGHT, function() {
				span.empty().append('<span class="glyphicon glyphicon glyphicon-ban-circle text-danger" />');
			});
		}
		for (var i = start; i < stop; i++) {
			loadThumbnail(i);
		}
	};

	/** Cette méthode indique visuellement la miniature sélectionnée et scrolle si elle est hors cadre */
	Diaporama.prototype.internalShowSelectedThumbnail = function() {
		// Récupérer quelques infos sur la zone des miniatures et la sélection
		var parent = this.target.children('.bbm-diaporama-thumbnails').get(0);
		if (parent.childNodes.length === 0)
			return;
		var parentScroll = parent.scrollLeft;
		var parentWidth = parent.clientWidth;
		var thumbnail = parent.childNodes[this.index];
		var thumbnailOffset = thumbnail.offsetLeft - parent.childNodes[0].offsetLeft;
		var thumbnailWidth = THUMBNAIL_WIDTH + THUMBNAIL_MARGIN + THUMBNAIL_PADDING;
		// Décalage à gauche ou à droite pour s'assurer que la sélection est visible
		if (thumbnailOffset < parentScroll)
			parent.scrollLeft = thumbnailOffset;
		else if (thumbnailOffset + thumbnailWidth > parentScroll + parentWidth)
			parent.scrollLeft = thumbnailOffset + thumbnailWidth - parentWidth;
		// Indiquer la miniature sélectionnée
		$(thumbnail).addClass('bbm-diaporama-thumbnail-selected').siblings().removeClass('bbm-diaporama-thumbnail-selected');
	};

	/** Cette méthode met à jour l'IHM en fonction de la présence ou non d'élements à afficher */
	Diaporama.prototype.deleteItem = function() {
		// Récupérer l'élément en cours
		var item = this.items[this.index];
		// Prévenir l'appelant de la demande de suppression, qui appelera la callback après une éventuelle confirmation
		this.onremove(item, function() {
			// On le retire le la liste
			this.items.splice(this.index, 1);
			// On le retire des miniatures
			var thumbnails = this.target.children('.bbm-diaporama-thumbnails');
			if (thumbnails.is(':visible')) {
				thumbnails.children(':nth-child(' + (this.index + 1) + ')').remove();
			}
			// Si on a supprimé le dernier élément
			if (this.items.length === 0) {
				// On désactive l'IHM
				this.index = undefined;
				// Ajuster la partie supérieure
				this.target.find('> .bbm-diaporama-toolbar .bbm-diaporama-action').hide();
				// Ajuster la partie centrale
				this.target.find('> .bbm-diaporama-content > .bbm-diaporama-view').empty()
					.next('.bbm-diaporama-open-details').hide()
					.next('.bbm-diaporama-details').hide()
					.children(':not(.close)').remove();
				// Ajuster la partie inférieure
				this.target.find('> .bbm-diaporama-pagination')
					.children('button').prop('disabled', true)
					.siblings('.bbm-diaporama-item-index').text('');
				// On "ferme" le diaporama si une callback a été fournie
				if (this.onclose)
					this.onclose();
			} else {
				// On charge l'élément à sa place ou, si c'était le dernier, celui d'avant
				this.show(Math.min(this.index, this.items.length - 1), true);
			}
		}.bind(this));
	};

	/** Cette méthode publique affiche ou cache les miniatures du diaporama */
	Diaporama.prototype.toggleThumbnails = function() {
		var parent = this.target.children('.bbm-diaporama-thumbnails').toggle();
		var pagination = this.target.children('.bbm-diaporama-pagination').toggleClass('bbm-diaporama-pagination-opened');
		var button = pagination.children('.bbm-diaporama-toggle-thumbnails');
		if (parent.is(':visible')) {
			// Ajuster le texte en "Cacher les miniatures"
			button.attr('title', this.lang.hideThumbnails);
			// Ajouter à la première ouverture les conteneurs de miniatures (mais pour l'instant sans miniature dedans) 
			if (parent.is(':empty')) {
				this.items.forEach(function(item) {
					var type = supports[item.type];
					if (!type)
						throw new Error('Type non supporté dans le diaporama : ' + item.type);
					$('<span class="bbm-diaporama-thumbnail bbm-diaporama-thumbnail-loading" />')
						.css('width', (THUMBNAIL_WIDTH + THUMBNAIL_PADDING) + 'px').css('height', (THUMBNAIL_HEIGHT + THUMBNAIL_PADDING) + 'px')
						.attr('title', item.title || item.url)
						.append('<span class="glyphicon glyphicon glyphicon-refresh" style="color: white;" />')
						.data('item', item).data('type', type)
						.appendTo(parent);
				});
			}
			// Charger les miniatures visibles à l'ouverture
			this.internalCheckVisibleThumbnails();
			// Marquer la sélection
			this.internalShowSelectedThumbnail();
			// Charger ensuite les miniatures apparaissant quand on scrolle
			parent.on('scroll', this.internalCheckVisibleThumbnails.bind(this));
		} else {
			// Ajuster le texte en "Afficher les miniatures"
			button.attr('title', this.lang.showThumbnails);
			// Ne plus écouter le scroll tant qu'il n'est pas visible
			parent.off('scroll');
			// Ne pas revider à chaque fois pour regénérer si on rouvre cette partie
			//parent.empty();
		}
		// Ajuster la taille de la partie centrale si le zoom choisi le nécessite
		this.internalAutoResize();
	};

	/** Cette méthode publique affiche ou cache le détail personnalisé de l'élément dans la partie droite */
	Diaporama.prototype.toggleDetails = function() {
		var openButton = this.target.children('.bbm-diaporama-content').children('.bbm-diaporama-open-details').toggle();
		var details = openButton.next('.bbm-diaporama-details').toggle();
		var item = this.items[this.index];
		details.children(':not(.close)').remove();
		if (details.is(':visible'))
			this.ondetails(details, item);
		this.internalAutoResize();
	};

	/** Cette méthode publique demande à afficher le premier élément du diaporama */
	Diaporama.prototype.showFirst = function() {
		this.show(0);
	};

	/** Cette méthode publique demande à afficher l'élément précédent du diaporama */
	Diaporama.prototype.showPrevious = function() {
		if (this.index > 0)
			this.show(this.index - 1);
	};

	/** Cette méthode publique demande à afficher l'élément suivant du diaporama */
	Diaporama.prototype.showNext = function() {
		if (this.index < this.items.length - 1)
			this.show(this.index + 1);
	};

	/** Cette méthode publique demande à afficher le dernier élément du diaporama */
	Diaporama.prototype.showLast = function() {
		this.show(this.items.length - 1);
	};

	/** Cette méthode publique demande à afficher l'élément du diaporama à la position demandée (le premier est à la position 0) */
	Diaporama.prototype.show = function(index, force) {
		if ((typeof index !== 'number') || index < 0 || index >= this.items.length)
			throw new Error('Index non valide ' + index + ' alors que la liste contient ' + this.items.length + ' éléments');
		if ((this.index !== index) || force) {
			// Mettre à jour l'index
			this.index = index;
			// Marquer la sélection
			this.internalShowSelectedThumbnail();
			// Activer ou non les boutons "Précédent" et "Suivant"
			this.target.find('.bbm-diaporama-previous-item').prop('disabled', index === 0);
			this.target.find('.bbm-diaporama-next-item').prop('disabled', index === this.items.length - 1);
			// Indiquer la progression "n sur N"
			var paginationText = this.lang.currentItemFormat.replace('%position', (index + 1)).replace('%count', this.items.length);
			this.target.children('.bbm-diaporama-pagination').children('.bbm-diaporama-item-index').text(paginationText);
			// MAJ de la barre d'outils
			var actions = this.target.children('.bbm-diaporama-toolbar').find('.bbm-diaporama-action');
			actions.hide();
			// MAJ de la vue centrale
			var item = this.items[index];
			var type = supports[item.type];
			var container = this.target.find('> .bbm-diaporama-content > .bbm-diaporama-view');
			type.buildContent(item, container.empty(), function(content) {
				this.content = content;
				// Download support
				if (item.download !== false) {
					actions.filter('.bbm-diaporama-download').show()
						.attr('href', item.downloadUrl || item.url)
						.attr('download', item.downloadName || item.title);
				}
				// Page support
				container.siblings('.bbm-diaporama-page-previous').toggle(this.content.supportsPaging);
				container.siblings('.bbm-diaporama-page-next').toggle(this.content.supportsPaging);
				if (this.content.supportsPaging) {
					var pageIndex = actions.filter('.bbm-diaporama-page-index').show();
					pageIndex.children('input').val(this.content.pageNumber.toString());
					pageIndex.children(':last-child').text(this.content.pageCount.toString());
					actions.filter('.bbm-diaporama-page-first,.bbm-diaporama-page-previous').show().prop('disabled', this.content.pageNumber === 1);
					actions.filter('.bbm-diaporama-page-last,.bbm-diaporama-page-next').show().prop('disabled', this.content.pageNumber === this.content.pageCount);
				}
				// Zoom support
				if (this.content.supportsZoom) {
					actions.filter('.bbm-diaporama-zoom-in,.bbm-diaporama-zoom-menu,.bbm-diaporama-zoom-out').show();
					this.target.find('> .bbm-diaporama-toolbar .bbm-diaporama-zoom-menu > span:first-child').text(Math.floor(this.content.zoom) + ' %');
				}
				// Rotation support
				if (this.content.supportsRotation) {
					actions.filter('.bbm-diaporama-rotate-ccw,.bbm-diaporama-rotate-cw').show();
				}
				// Media play/pause/resume support
				if (this.content.supportsMedia) {
					actions.filter('.bbm-diaporama-play').show();
				}
				// Media mute/unmute support
				if (this.content.supportsMute) {
					actions.filter('.bbm-diaporama-mute').show();
				}
				// Detail panel on the right side
				var details = this.target.find('> .bbm-diaporama-content > .bbm-diaporama-details');
				details.children(':not(.close)').remove();
				if (details.is(':visible'))
					this.ondetails(details, item);

			}.bind(this), function() {
				container.empty().append('<div class="text-danger">' + this.lang.contentError + '</div>');
				this.content = new DiaporamaContent();
			}.bind(this));

			// Affichage du bouton de suppression même si on n'arrive pas à afficher le contenu
			if (this.onremove && (!this.oncanremove || this.oncanremove(item))) {
				actions.filter('.bbm-diaporama-remove').show();
			}
		}
	};

	/** Cette méthode "statique" retourne une map indiquant le type de support par extension supportée sur ce navigateur */
	function getSupportMapByExtensions() {
		var result = {};
		for (var p in supports) {
			var support = supports[p];
			if (! support.getExtensions)
				continue;
			var extensions = support.getExtensions();
			for (var i = 0; i < extensions.length; i++) {
				result[extensions[i]] = p;
			}
		}
		return result;
	}

	var langs = {
		'fr': frenchLocale,
		'en': englishLocale,
		'de': germanLocale
	};

	var supports = {
		'image': new ImageSupport(),
		'audio': new AudioSupport(),
		'video': new VideoSupport(),
		'gif': new GifSupport(),
	};
	if (pdfjsLib)
		supports['pdf'] = new PDFSupport(pdfjsLib);

	// Composant diaporama en jQuery, proposant 3 appels possibles
	$.fn.diaporama = function(items, options) {
		// 1. Création avec .diaporama([ items ], { options });
		if (Array.isArray(items)) {
			return this.each(function() {
				$(this).data('diaporama', new Diaporama(this, items, options));
			});
		}

		// 2. Récupération avec .diaporama();
		if (typeof items === 'undefined') {
			return this.data('diaporama');
		}

		// 3. Destruction avec .diaporama('destroy');
		if (items === 'destroy') {
			return this.each(function() {
				var self = $(this), diaporama = self.data('diaporama');
				if (diaporama) {
					diaporama.destroy();
					self.removeData('diaporama');
				}
			});
		}

		// Erreur sinon
		throw new Error('Paramètre non supporté pour le composant diaporama : ' + items);
	};

	return {
		Content: DiaporamaContent,
		Diaporama: Diaporama,
		getLang: function(locale) {
			return langs[locale];
		},
		addLang: function(locale, values) {
			langs[locale] = values;
		},
		getSupport: function(name) {
			return supports[name];
		},
		addSupport: function(name, definition) {
			supports[name] = definition;
		},
		getSupportMapByExtensions: getSupportMapByExtensions
	};
};
